module.exports = __webpack_public_path__ + "static/media/merriweather-light-webfont.c370c7b6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-light-webfont.woff
// module id = 284
// module chunks = 0